import { connect } from 'react-redux';
import {
  getSecondaryMarketRtFormCanEditUpfrontFee,
  getSecondaryMarketRtFormHasUpfrontFee,
  getSecondaryMarketRtFormNotional,
  getSecondaryMarketRtFormQuantity,
  getSecondaryMarketRtFormTotalUnallocatedNotional,
  getSecondaryMarketRtFormTradeWay,
} from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm/realTimeQuoteForm.selectors';
import {
  secondaryMarketRtFormNotionalChangedThunk,
  secondaryMarketRtFormQuantityChangedThunk,
  secondaryMarketRtFormTradeWayChangedThunk,
  secondaryMarketRtFormUpfrontFeeChangedThunk,
} from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm/realtimeQuoteForm.thunks';
import { getSecondaryMarketRealtimeAstroProductFromTab } from 'state/secondaryMarket/referential/astroProduct/astroProduct.selectors';
import type { TradeWay } from 'state/secondaryMarket/secondaryMarket.model';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { getTabIsFrozen } from 'state/workspaces/tabs/tabs.selector';

type OwnProps = Readonly<{
  tabId: string;
}>;

type StateProps = Readonly<{
  name?: string;
  currency: string;
  canEditUpfrontFee: boolean;
  hasUpfrontFee: boolean | undefined;
  notional: number | undefined;
  quantity: number | undefined;
  unallocatedNotional: number | undefined;
  tradeWay: TradeWay;
  frozen: boolean;
}>;

type DispatchProps = Readonly<{
  onTradeWayChanged: (tradeWay: TradeWay) => void;
  onUpfrontFeeChanged: (value: boolean) => void;
  onNotionalChanged: (value: number | undefined) => void;
  onQuantityChanged: (value: number | undefined) => void;
}>;
export type QuoteRealtimeFormDetailsProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const product = getSecondaryMarketRealtimeAstroProductFromTab(state, tabId)?.data;
  const quantity = getSecondaryMarketRtFormQuantity(state, tabId);
  const notional = getSecondaryMarketRtFormNotional(state, tabId);
  const hasUpfrontFee = getSecondaryMarketRtFormHasUpfrontFee(state, tabId);
  const canEditUpfrontFee = getSecondaryMarketRtFormCanEditUpfrontFee(state, tabId);
  const tradeWay = getSecondaryMarketRtFormTradeWay(state, tabId)!;
  const unallocatedNotional = getSecondaryMarketRtFormTotalUnallocatedNotional(state, tabId);
  const frozen = getTabIsFrozen(state, tabId) ?? false;

  return {
    name: product?.productId,
    canEditUpfrontFee,
    quantity,
    currency: product?.currency!,
    frozen,
    notional,
    hasUpfrontFee,
    tradeWay,
    unallocatedNotional,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => {
  return {
    onNotionalChanged(notional) {
      dispatch(secondaryMarketRtFormNotionalChangedThunk(tabId, notional));
    },
    onQuantityChanged(quantity) {
      dispatch(secondaryMarketRtFormQuantityChangedThunk(tabId, quantity));
    },
    onTradeWayChanged(tradeWay) {
      dispatch(secondaryMarketRtFormTradeWayChangedThunk(tabId, tradeWay));
    },
    onUpfrontFeeChanged(hasUpfrontFee) {
      dispatch(secondaryMarketRtFormUpfrontFeeChangedThunk(tabId, hasUpfrontFee));
    },
  };
};
export const connectQuoteRealtimeFormDetail = connect(mapStateToProps, mapDispatchToProps);
